import React, { useMemo } from 'react';
import cn from 'classnames';
import { ButtonWithIcon } from '@els/els-react--button';
import ContextsSwitcher from '@Containers/ResultToolbar/ContextsSwitcher';

import './ResultTopPanel.scss';

function isEditQueryEnabledFn(activeBreadcrumb) {
  return activeBreadcrumb?.getIn(['quickSearchItem', 'whereClauseImportToken']) || activeBreadcrumb?.get('queryFactItem');
}

function ResultTopPanel({
  params,
  className,
  activeBreadCrumb,
  activeBreadCrumbContext,
  totalResult,
  isTgitemsContext,
  isReactionsContext,
  isCitationsContext,
  isSubstancesContext,
  availableRelativeContext,
  goToResultPage,
  saveSearch,
  editInQueryBuilder,
  dispatchCreateAlert,
}) {
  const isEditQueryEnabled = useMemo(() => isEditQueryEnabledFn(activeBreadCrumb), [activeBreadCrumb]);

  const saveSearchHandler = () => {
    const searchData = activeBreadCrumb?.toJS() || {};
    const { sort, order } = params || {};
    saveSearch({ ...searchData, sort, order });
  };

  return (
    <div
      className={cn(
        'result-top-panel u-els-padding-left-2x u-els-padding-right-2x u-els-padding-top u-els-padding-bottom o-els-flex-layout o-els-flex-layout--space-between o-els-flex-layout--bottom',
        className
      )}>
      <ContextsSwitcher
        className="o-els-flex-layout__item"
        activeBreadCrumb={activeBreadCrumb}
        activeBreadCrumbContext={activeBreadCrumbContext}
        totalResult={totalResult}
        isTgitemsContext={isTgitemsContext}
        isReactionsContext={isReactionsContext}
        isCitationsContext={isCitationsContext}
        isSubstancesContext={isSubstancesContext}
        availableRelativeContext={availableRelativeContext}
        goToResultPage={goToResultPage}
      />
      <div className="o-els-flex-layout__item" aria-label="Query actions">
        <ButtonWithIcon
          type="link"
          iconRight
          linkIconSize="xs"
          sprite="SaveFile"
          className="u-els-margin-right"
          onClick={saveSearchHandler}
          data-e2e="save-search-button">
          Save search
        </ButtonWithIcon>
        <ButtonWithIcon
          type="link"
          iconRight
          linkIconSize="xs"
          sprite="Alarm"
          className="u-els-margin-right"
          disabled={!isEditQueryEnabled}
          onClick={() => {
            dispatchCreateAlert(activeBreadCrumb?.toJS());
          }}
          data-e2e="create-alert-button">
          Create alert
        </ButtonWithIcon>
        <ButtonWithIcon
          type="link"
          iconRight
          linkIconSize="xs"
          sprite="Note"
          disabled={!isEditQueryEnabled}
          onClick={() => {
            editInQueryBuilder(activeBreadCrumb?.toJS());
          }}
          data-e2e="edit-in-query-builder-button">
          Edit in Query Builder
        </ButtonWithIcon>
      </div>
    </div>
  );
}

export default ResultTopPanel;
